import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';
import { Input, InputProps } from 'shared/ui/Input';

interface Props extends InputProps {
	name: string;
	label: string;
	placeholder: string;
	type?: 'text' | 'email' | 'password' | 'number';
	required?: boolean;
	fullWidth?: boolean;
	disabled?: boolean;
	multiline?: boolean;
	// setFieldValue?: FormikHelpers<string | number>['setFieldValue'];
}

export const InputField: FunctionComponent<Props> = ({ ...props }) => {
	const { t } = useTranslation();
	const [field, meta] = useField(props.name);

	return (
		<Input
			{...field}
			{...props}
			errorText={meta.touched && meta.error ? (t(`${meta.error}`) as string) : undefined}
		/>
	);
};
